import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getResponseMessage } from '../../../../utils/utils';
import { useFormatMessage } from '../../../../hooks';
import { getStores } from '../../../../crud/store.crud';
import { IStore } from '../../../../interfaces/store';

export const useGetStores = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const fm = useFormatMessage();
  const [stores, setStores] = useState<IStore[]>([]);

  const fetchStores = useCallback(
    async (page: number, perPage: number, companyId: number) => {
      setLoading(true);
      getStores(page, perPage, companyId)
        .then(res => {
          setStores(res.data.data);
        })
        .catch(e => {
          enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`, { variant: 'error' });
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [dispatch]
  );

  return {
    fetchStores,
    loading,
    stores,
  };
};
